import React from "react";
import { Filter } from 'react-admin';

import TextInputEx from "../../../components/_extensions/react-admin/input/TextInputEx";
import { ThirdPartyAppStatusFilter } from "./ThirdPartyAppStatusFilter";


export const ThirdPartyAppsFilter = ({ showStatusFilter = false, ...props }) => (
	<Filter {...props}>
		{showStatusFilter && <ThirdPartyAppStatusFilter source="status" alwaysOn key="status" />}
		<TextInputEx source="client_name" />
		<TextInputEx source="client_id" />
		<TextInputEx source="redirect_uri" />
	</Filter>
);
